var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.data.title))]),
      _c(
        "w-scroll-view",
        {
          style: { overflow: "hidden", height: "100%" },
          attrs: { tag: "w-list", "no-padding": "" },
        },
        [
          _c(
            "w-list-item",
            { staticClass: "marked" },
            [
              _c("w-list-item-text"),
              _c("w-list-item-text", { style: { textAlign: "right" } }, [
                _vm._v(_vm._s(_vm.$ct("income"))),
              ]),
              _c("w-list-item-text", { style: { textAlign: "right" } }, [
                _vm._v(_vm._s(_vm.$ct("costs"))),
              ]),
              _c("w-list-item-text", { style: { textAlign: "right" } }, [
                _vm._v(_vm._s(_vm.$ct("difference"))),
              ]),
            ],
            1
          ),
          _vm._l(_vm.result, function (entry, i) {
            return _c(
              "w-list-item",
              { key: i, staticClass: "row" },
              [
                _c("w-list-item-text", { staticClass: "month" }, [
                  _vm._v(_vm._s(_vm.$ct("common.months." + (i + 1)))),
                ]),
                _c("w-list-item-text", { style: { textAlign: "right" } }, [
                  _vm._v(_vm._s(_vm.printNum(entry.income))),
                ]),
                _c("w-list-item-text", { style: { textAlign: "right" } }, [
                  _vm._v(_vm._s(_vm.printNum(entry.cost))),
                ]),
                _c("w-list-item-text", { style: { textAlign: "right" } }, [
                  _vm._v(_vm._s(_vm.printNum(entry.difference))),
                ]),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            { staticClass: "marked" },
            [
              _c("w-list-item-text"),
              _c("w-list-item-text", { style: { textAlign: "right" } }, [
                _vm._v(_vm._s(_vm.printNum(_vm.totalRow.income))),
              ]),
              _c("w-list-item-text", { style: { textAlign: "right" } }, [
                _vm._v(_vm._s(_vm.printNum(_vm.totalRow.cost))),
              ]),
              _c("w-list-item-text", { style: { textAlign: "right" } }, [
                _vm._v(_vm._s(_vm.printNum(_vm.totalRow.difference))),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }